export interface IFilterData {
    centerId: number,
    show: number,
    status: number,
    alias: string,
    phiEmail: string,
    dob: string,
    recipientId: number
}